import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Timetable from './components/Timetable';
import Flash from './components/Flash';
import HotRank from './components/HotRank';
import Columns from './components/Columns';
import Guide from './components/Guide';
import Faq from './components/Faq';
import About from './components/About';
import Subscribe from './components/Subscribe';
import Footer from './components/Footer';
import BackTop from './components/BackTop';

const orgSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://deshengzuche.cn/#org',
      name: '大瓜预警',
      url: 'https://deshengzuche.cn/',
      email: 'hello@daguayujing.example',
      logo: 'https://deshengzuche.cn/logo.png',
      description: '整理娱乐话题节奏的蹲瓜时间表资讯站，覆盖周一见、周五晚、周末大瓜、月末盘点与季度压轴。',
    },
    {
      '@type': 'WebSite',
      '@id': 'https://deshengzuche.cn/#website',
      url: 'https://deshengzuche.cn/',
      name: '大瓜预警 - 蹲瓜时间表资讯站',
      inLanguage: 'zh-CN',
      publisher: { '@id': 'https://deshengzuche.cn/#org' },
    },
    {
      '@type': 'WebPage',
      '@id': 'https://deshengzuche.cn/#webpage',
      url: 'https://deshengzuche.cn/',
      name: '大瓜预警：周一见、周五晚、周末大瓜、月末盘点、季度压轴蹲点指南',
      inLanguage: 'zh-CN',
      isPartOf: { '@id': 'https://deshengzuche.cn/#website' },
    },
  ],
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }} />
      <Navbar />
      <main>
        <Hero />
        <Timetable />
        <Flash />
        <HotRank />
        <Columns />
        <Guide />
        <Faq />
        <About />
        <Subscribe />
      </main>
      <Footer />
      <BackTop />
    </>
  );
}